module.exports = __webpack_public_path__ + "static/media/wmTrial-words-1.024e9a8e.mp3";